import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import './chartSetup';
import { CHART_COLORS, defaultChartOptions } from './chartSetup';

const formatDateLabel = (dateString) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return `${date.getDate()}/${date.getMonth() + 1}`;
};

const LineTrendChart = ({
  data = [],
  label = 'Count',
  color = CHART_COLORS.green,
  yAxisLabel = 'Count'
}) => {
  const chartData = useMemo(() => ({
    labels: data.map((item) => formatDateLabel(item.date)),
    datasets: [{
      label,
      data: data.map((item) => item.count),
      borderColor: color,
      backgroundColor: `${color}22`,
      pointBackgroundColor: color,
      pointBorderColor: '#ffffff',
      pointBorderWidth: 2,
      pointRadius: 4,
      pointHoverRadius: 6,
      tension: 0.35,
      fill: true
    }]
  }), [data, label, color]);

  const options = useMemo(() => ({
    ...defaultChartOptions,
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#6b7280', maxRotation: 0 }
      },
      y: {
        beginAtZero: true,
        grid: { color: '#f3f4f6' },
        ticks: { color: '#6b7280', precision: 0 },
        title: {
          display: Boolean(yAxisLabel),
          text: yAxisLabel,
          color: '#6b7280',
          font: { size: 11 }
        }
      }
    }
  }), [yAxisLabel]);

  if (!data.length) {
    return (
      <div className="h-72 flex items-center justify-center text-sm text-gray-500">
        No trend data available
      </div>
    );
  }

  return (
    <div className="h-72" role="img" aria-label={`${label} trend chart`}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LineTrendChart;
